import React from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';

const DataErrorFallback = ({ 
  title = 'Veri Yüklenemedi',
  message = 'İçerik yüklenirken bir sorun oluştu. Lütfen tekrar deneyin.',
  onRetry,
  showHomeButton = true,
  showRetryButton = true,
  icon = 'AlertCircle',
  variant = 'default'
}) => {
  const variantStyles = {
    default: {
      bgColor: 'bg-red-100',
      iconColor: 'text-red-600',
      containerBg: 'bg-background'
    },
    '404': {
      bgColor: 'bg-amber-100',
      iconColor: 'text-amber-600',
      containerBg: 'bg-background'
    },
    network: {
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
      containerBg: 'bg-background'
    }
  };

  const styles = variantStyles?.[variant] || variantStyles?.default;

  return (
    <div className={`flex items-center justify-center min-h-[400px] ${styles?.containerBg}`}>
      <div className="text-center max-w-md px-4">
        <div className={`${styles?.bgColor} p-4 rounded-full inline-flex mb-4`}>
          <Icon name={icon} size={48} className={styles?.iconColor} />
        </div>
        
        <h2 className="text-2xl font-bold text-foreground mb-2">
          {title}
        </h2>
        
        <p className="text-muted-foreground mb-6">
          {message}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {showRetryButton && (
            <Button
              onClick={onRetry || (() => window.location?.reload())}
              variant="default"
              iconName="RefreshCw"
            >
              Tekrar Dene
            </Button>
          )}
          
          {showHomeButton && (
            <Button
              onClick={() => window.location.href = '/'}
              variant="outline"
              iconName="Home"
            >
              Ana Sayfa
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataErrorFallback;